import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { ExtranetPackagesResponse } from 'app/typings/core/extranet/packages/packages';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function usePackages(hotelId: number) {
  const key = useMemo(() => {
    return [CORE_QUERY_KEYS.packages, hotelId];
  }, [hotelId]);

  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getPackages,
        params: { hotelId: hotelId.toString() },
      }) as Promise<ExtranetPackagesResponse>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
